import { action } from 'typesafe-actions'

import { TranslationsActionConsts } from './types'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const setLanguage = (language: string, keys: Record<string, any>) =>
  action(TranslationsActionConsts.SET_LANGUAGE, { language, keys })
